<template>
  <div id="reset-password" class="w-100 h-100 row mx-0">
    <form
      class="col-12 col-md-4 offset-md-4 form-horizontal"
      @submit.prevent="onSubmit()"
    >
      <div class="form-group">
        <img :src="'/static/icons/brj-th.svg'" class="logo" />
      </div>
      <div class="header">
        <span v-if="stage === 'ok'">
          {{ $t("feature.forgot_password.title.main") }}
        </span>
        <span v-if="stage === 'success'">
          {{ $t("feature.forgot_password.title.success") }}
        </span>
        <span v-if="stage === 'fail'">
          {{ $t("feature.forgot_password.title.fail") }}
        </span>
      </div>
      <div class="content">
        <span v-if="stage === 'ok'">
          {{ $t("feature.forgot_password.detail.main") }} {{ email }}
          <br />
          {{ $t("feature.forgot_password.detail.format") }}
        </span>
        <span v-if="stage === 'success'">
          {{ $t("feature.forgot_password.title.success") }}
        </span>
        <span v-if="stage === 'fail'">
          {{ $t("feature.forgot_password.title.fail") }}
        </span>
        <span v-if="stage === 'loading'">
          {{ $t("feature.forgot_password.title.loading") }}
        </span>
      </div>
      <div v-if="stage === 'ok'">
        <div class="form-group">
          <div class="title-input media">
            <span v-show="password" class="me-1">{{
              $t("feature.forgot_password.password")
            }}</span>
            <span
              v-show="errors.first('password')"
              class="media-body text-end text-error"
            >
              {{ errors.first("password") }}
            </span>
          </div>
          <input
            v-model="password"
            v-validate="{
              required: true,
              min: 8,
              max: 16,
              regex: '^[A-Za-z0-9]+$'
            }"
            :placeholder="$t('feature.forgot_password.password')"
            :class="{ error: errors.has('password') | error }"
            type="password"
            class="form-control"
            name="password"
          />
        </div>
        <div class="form-group">
          <div class="title-input media">
            <span v-show="passwords" class="me-1">{{
              $t("feature.forgot_password.passwords")
            }}</span>
            <span
              v-show="errors.first('passwords')"
              class="media-body text-end text-error"
            >
              {{ errors.first("passwords") }}
            </span>
          </div>
          <input
            v-model="passwords"
            v-validate="{
              required: true,
              min: 8,
              max: 16,
              regex: '^[A-Za-z0-9]+$',
              confirmed: matchPassword
            }"
            :placeholder="$t('feature.forgot_password.passwords')"
            :class="{ error: errors.has('passwords') | error }"
            type="password"
            class="form-control"
            name="passwords"
          />
        </div>
        <div class="form-group">
          <button type="submit" class="btn-reset w-100">
            {{ $t("feature.forgot_password.reset_password") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      password: "",
      passwords: "",
      stage: "loading",
      error: "",
      email: ""
    };
  },
  computed: {
    matchPassword() {
      return this.password !== this.passwords;
    }
  },
  beforeMount() {
    const vm = this;
    axios
      .post(
        `${process.env.HOST}/api/auth/forgotpassword/verify/token/${
          this.$route.query.token
        }`
      )
      .then(res => {
        vm.stage = "ok";
        vm.email = res.data.email;
      })
      .catch(e => {
        vm.stage = "fail";
        throw e;
      });
  },
  methods: {
    onSubmit() {
      const vm = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .post(
              `${process.env.HOST}/api/auth/resetpassword/token/${
                this.$route.query.token
              }`,
              { password: vm.password }
            )
            .then(() => {
              vm.stage = "success";
            })
            .catch(e => {
              vm.error = "fail";
              throw e;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
#reset-password {
  background-color: #fffaf6;
}
.form-control {
  box-shadow: none;
  border: none;
  border-bottom: solid 1px #dac0b2;
  border-radius: 0px;
  background-color: transparent;
  padding: 3px;

  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.22;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
}
.form-control:hover,
.form-control:focus {
  box-shadow: none;
  border-bottom: solid 1px #4a4a4a;
}
.form-control.error {
  border-bottom: solid 1px #fe676f;
}
.header {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: left;
  color: #44281b;
}
.content {
  text-align: left;
  font-size: 17px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.53;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
}
.title-input {
  height: 17px;
  font-size: 11px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  text-align: left;
  color: #8c8786;
}
.form-group {
  margin-top: 15px;
  text-align: left;
}
input {
  height: 30px !important;
}
.logo {
  margin-top: 20px;
  margin-bottom: 20px;
}
.text-error {
  color: #fe676f;
}
.btn-reset {
  height: 40px;
  object-fit: contain;
  border-radius: 12px;
  background-color: #e27024;
  border: none;

  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: center;
  color: #ffffff;
}
</style>
